import { useEffect, useState } from 'react'
import { supabase } from '../data/supabase.js'
import { getFcmToken } from '../data/firebase.js'

export function usePushNotification(session) {
  const [permissao, setPermissao] = useState('Notification' in window ? Notification.permission : 'denied')
  const [ativo, setAtivo] = useState(false)
  const [carregando, setCarregando] = useState(false)

  // Sempre que logar: se já tem permissão, garante token no banco
  useEffect(() => {
    if (!session?.usuarioId) return
    if (!session?.empresaId) return  // super admin sem empresa não usa push
    // Verificar se há sessão Supabase (JWT) — login local fallback não deve usar push
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) registrarTokenSePermitido()
    })
  }, [session?.usuarioId])

  async function registrarTokenSePermitido() {
    if (!('Notification' in window)) return
    if (Notification.permission !== 'granted') {
      setAtivo(false)
      return
    }
    setAtivo(true)
    try {
      const { data } = await supabase
        .from('push_subscriptions')
        .select('endpoint')
        .eq('usuario_id', session.usuarioId)
        .limit(1)
      if (!data || data.length === 0) {
        const token = await getFcmToken()
        if (token) await salvarToken(token)
      }
    } catch (err) {
      console.error('[Push] Erro ao registrar token:', err)
    }
  }

  // Solicita permissão e salva token — chamado pelo toggle na UI
  async function ativarPush() {
    if (!('Notification' in window)) {
      alert('Seu navegador não suporta notificações.')
      return false
    }
    setCarregando(true)
    try {
      const permission = await Notification.requestPermission()
      setPermissao(permission)
      if (permission !== 'granted') {
        setCarregando(false)
        return false
      }
      const token = await getFcmToken()
      if (!token) throw new Error('Não foi possível obter token FCM')
      await salvarToken(token)
      setAtivo(true)
      setCarregando(false)
      return true
    } catch (err) {
      console.error('[Push] Erro ao ativar:', err)
      setCarregando(false)
      return false
    }
  }

  // Apenas marca como inativo na UI — NÃO remove token do banco
  // O token permanece para continuar recebendo push mesmo após fechar/deslogar
  async function desativarPush() {
    setAtivo(false)
  }

  async function salvarToken(token) {
    if (!session?.usuarioId) return
    const { error } = await supabase.from('push_subscriptions').upsert({
      usuario_id: session.usuarioId,
      empresa_id: session.empresaId,
      perfil: session.perfil,
      endpoint: token,
      p256dh: null,
      auth: null,
      atualizado_em: Date.now()
    }, { onConflict: 'endpoint' })
    if (error) console.error('[Push] Erro ao salvar token:', error.message)
  }

  return { permissao, ativo, carregando, ativarPush, desativarPush }
}
